import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const KeyScalingToggle = ({parameter}) => { 
    const [toggled, setToggled] = useState(parameter && parameter.keyScaling !== undefined);

    useEffect(() => {
        if (parameter) {
            setToggled(parameter.keyScaling !== undefined);
        }
    }, [parameter, setToggled]);
    
    const onClick = useCallback(() => {
        if (toggled) {
            parameter.disableKeyScaling();
        } else {
            parameter.enableKeyScaling();
        }
        if (parameter.context.track) {
            console.log("clearing cache");
            parameter.context.track.parametersToScale = undefined;
        }
        setToggled(!toggled);
    }, [parameter, setToggled, toggled]);

    let className = "key-scaling-toggle pushable ";
    if (toggled) {
        className = "key-scaling-toggled pushable";
    }
    return (
        <div
          onClick={onClick}
          className={className}>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(KeyScalingToggle);
